const r = ':host{display:block;width:100%}.sl-input{box-sizing:border-box;display:block;width:100%;height:2.25rem;padding:0.25rem var(--sl-spacing-3);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);line-height:1.5;color:hsl(var(--sl-hsl-foreground));background-color:hsl(var(--sl-hsl-input));border:1px solid hsl(var(--sl-hsl-border));border-radius:var(--sl-radius-md);box-shadow:var(--sl-shadow-sm);transition:border-color var(--sl-transition-fast),box-shadow var(--sl-transition-fast);outline:none}.sl-input::placeholder{color:hsl(var(--sl-hsl-muted-foreground))}.sl-input:hover:not(:disabled):not(:read-only){border-color:hsl(var(--sl-hsl-primary-200))}.sl-input:focus{border-color:hsl(var(--sl-hsl-primary));box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-input--error{border-color:hsl(var(--sl-hsl-destructive))}.sl-input--error:hover:not(:disabled):not(:read-only){border-color:hsl(var(--sl-hsl-destructive))}.sl-input--error:focus{border-color:hsl(var(--sl-hsl-destructive));box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-destructive))}.sl-input__feedback{display:block;font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-xs);line-height:1.4;margin-top:var(--sl-spacing-1);color:hsl(var(--sl-hsl-muted-foreground))}.sl-input__feedback--error{color:hsl(var(--sl-hsl-destructive))}.sl-input__feedback[hidden]{display:none}.sl-input--disabled,.sl-input--readonly{cursor:not-allowed}.sl-input:disabled{opacity:0.5}.sl-input:read-only{background-color:hsl(var(--sl-hsl-muted))}.sl-input[type="file"]{padding:var(--sl-spacing-2) var(--sl-spacing-3)}.sl-input[type="file"]::file-selector-button{margin-right:var(--sl-spacing-2);padding:var(--sl-spacing-1) var(--sl-spacing-2);border:1px solid hsl(var(--sl-hsl-border));border-radius:var(--sl-radius-sm);background-color:hsl(var(--sl-hsl-input));color:hsl(var(--sl-hsl-foreground));font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);cursor:pointer;transition:background-color var(--sl-transition-fast)}.sl-input[type="file"]::file-selector-button:hover{background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}@media (max-width:768px){.sl-input{font-size:16px}}';
let i = 0;
class l extends HTMLElement {
  constructor() {
    super(), this._handleInputBound = this._handleInput.bind(this), this._handleFocusBound = this._handleFocus.bind(this), this._handleBlurBound = this._handleBlur.bind(this), this._shadow = this.attachShadow({ mode: "open" }), this._feedbackId = `sl-input-feedback-${++i}`, this._render();
  }
  static get observedAttributes() {
    return ["value", "type", "placeholder", "disabled", "readonly", "name", "required", "error", "error-message", "helper-text"];
  }
  connectedCallback() {
    this._input.addEventListener("input", this._handleInputBound), this._input.addEventListener("focus", this._handleFocusBound), this._input.addEventListener("blur", this._handleBlurBound);
  }
  disconnectedCallback() {
    this._input.removeEventListener("input", this._handleInputBound), this._input.removeEventListener("focus", this._handleFocusBound), this._input.removeEventListener("blur", this._handleBlurBound);
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._updateInput();
  }
  _handleInput(e) {
    const t = e.target;
    this.dispatchEvent(
      new CustomEvent("input", {
        bubbles: !0,
        composed: !0,
        detail: { value: t.value }
      })
    ), this.dispatchEvent(
      new CustomEvent("update:value", {
        bubbles: !0,
        composed: !0,
        detail: { value: t.value }
      })
    );
  }
  _handleFocus(e) {
    this.dispatchEvent(
      new CustomEvent("focus", {
        bubbles: !0,
        composed: !0,
        detail: { originalEvent: e }
      })
    );
  }
  _handleBlur(e) {
    this.dispatchEvent(
      new CustomEvent("blur", {
        bubbles: !0,
        composed: !0,
        detail: { originalEvent: e }
      })
    );
  }
  get value() {
    return this.getAttribute("value") || "";
  }
  set value(e) {
    this.setAttribute("value", e), this._input.value = e;
  }
  get type() {
    return this.getAttribute("type") || "text";
  }
  set type(e) {
    this.setAttribute("type", e);
  }
  get placeholder() {
    return this.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.setAttribute("placeholder", e);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get readonly() {
    return this.hasAttribute("readonly");
  }
  set readonly(e) {
    e ? this.setAttribute("readonly", "") : this.removeAttribute("readonly");
  }
  get name() {
    return this.getAttribute("name");
  }
  set name(e) {
    e ? this.setAttribute("name", e) : this.removeAttribute("name");
  }
  get required() {
    return this.hasAttribute("required");
  }
  set required(e) {
    e ? this.setAttribute("required", "") : this.removeAttribute("required");
  }
  get error() {
    return this.hasAttribute("error");
  }
  set error(e) {
    e ? this.setAttribute("error", "") : this.removeAttribute("error");
  }
  get errorMessage() {
    return this.getAttribute("error-message") || "";
  }
  set errorMessage(e) {
    e ? this.setAttribute("error-message", e) : this.removeAttribute("error-message");
  }
  get helperText() {
    return this.getAttribute("helper-text") || "";
  }
  set helperText(e) {
    e ? this.setAttribute("helper-text", e) : this.removeAttribute("helper-text");
  }
  _updateInput() {
    this._input.type = this.type, this._input.placeholder = this.placeholder, this._input.disabled = this.disabled, this._input.readOnly = this.readonly, this._input.value = this.value, this._input.className = this._getInputClasses(), this.error ? this._input.setAttribute("aria-invalid", "true") : this._input.removeAttribute("aria-invalid"), this.required ? this._input.setAttribute("aria-required", "true") : this._input.removeAttribute("aria-required"), this._updateFeedback();
  }
  _updateFeedback() {
    const e = this.error && this.errorMessage.length > 0, t = !e && this.helperText.length > 0, s = e ? this.errorMessage : t ? this.helperText : "";
    this._feedback.textContent = s, this._feedback.className = e ? "sl-input__feedback sl-input__feedback--error" : "sl-input__feedback", s ? (this._feedback.removeAttribute("hidden"), this._input.setAttribute("aria-describedby", this._feedbackId)) : (this._feedback.setAttribute("hidden", ""), this._input.removeAttribute("aria-describedby"));
  }
  _getInputClasses() {
    const e = ["sl-input"];
    return this.disabled && e.push("sl-input--disabled"), this.readonly && e.push("sl-input--readonly"), this.error && e.push("sl-input--error"), e.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${r}</style>
      <input
        type="${this.type}"
        class="${this._getInputClasses()}"
        placeholder="${this.placeholder}"
        ?disabled="${this.disabled}"
        ?readonly="${this.readonly}"
        value="${this.value}"
      />
      <span class="sl-input__feedback" id="${this._feedbackId}" hidden></span>
    `, this._input = this._shadow.querySelector("input"), this._feedback = this._shadow.querySelector(".sl-input__feedback"), this._updateInput();
  }
  focus() {
    this._input.focus();
  }
  blur() {
    this._input.blur();
  }
  select() {
    this._input.select();
  }
  setSelectionRange(e, t, s) {
    this._input.setSelectionRange(e, t, s);
  }
}
typeof customElements < "u" && !customElements.get("sl-input") && customElements.define("sl-input", l);
export {
  l as SlInputElement
};
//# sourceMappingURL=sl-input.js.map
